import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import { styled } from '@tmap/mmm-style-guide/src/styled';
import { Typography } from '@tmap/mmm-style-guide/src/Typography';
import { OpenInNew } from '@tmap/mmm-style-guide/src/Icon';
import { offerTypeFromValue } from '../../lib/filterTypes';

const IconBackground = styled('div')(({ theme }) => ({
  color: theme.palette.secondary.main,
  background: 'rgba(95, 194, 135, 0.08)',
  borderRadius: '8px',
  padding: theme.spacing(0.5),
  display: 'inline-flex',
}));

const LinkTypography = styled(Typography)(() => ({
  cursor: 'pointer',
  '&:hover': {
    textDecoration: 'underline',
  },
}));

function OfferValueItem(props) {
  const {
    offerValue,
    showIcon = true,
    valueProps = {},
    iconProps = {},
    disableLinks = false,
  } = props;

  const {
    icon: TypeIcon,
    title: typeLabel,
  } = offerTypeFromValue(offerValue.valueType);

  return (
    <Grid container alignItems='center' spacing={1}>
      {showIcon && (
        <Grid item>
          <IconBackground>
            <TypeIcon fontSize='small' {...iconProps} />
          </IconBackground>
        </Grid>
      )}
      <Grid item xs>
        <Grid container spacing={1}>
          <Grid item xs sx={{ display: 'flex', alignItems: 'center' }}>
            {(offerValue.valueLink && !disableLinks) ? (
              <a href={offerValue.valueLink} target='_blank' rel='noreferrer noopener'>
                <LinkTypography variant='body1' component='span' {...valueProps}>
                  {offerValue.valueDescription || typeLabel}
                  <OpenInNew sx={{ fontSize: '16px', marginLeft: 0.5, marginBottom: -0.25 }} />
                </LinkTypography>
              </a>
            ) : (
              <Typography variant='body1' component='span' {...valueProps}>{offerValue.valueDescription || typeLabel}</Typography>
            )}
          </Grid>
          <Grid item text='right'>
            <Typography variant='body1' color='textSecondary'>{offerValue.valueText}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default OfferValueItem;
